import { axios } from '@Root/API'

export const get = () => {
	return axios.get('content/application-form')
}
